// extracted by mini-css-extract-plugin
export default {"root":"DeleteOptionModal_root__CAHp4","question":"DeleteOptionModal_question__mjmwW"};